module["exports"] = [
  "#####",
  "####",
  "###"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/pt_BR/address/building_number.js
 ** module id = 943
 ** module chunks = 0
 **/